/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Waive_RequirementsInputs */

const en_task_field_waive_requirements = /** @type {(inputs: Task_Field_Waive_RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirements waived`)
};

const pt_br2_task_field_waive_requirements = /** @type {(inputs: Task_Field_Waive_RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requisitos dispensados`)
};

/**
* | output |
* | --- |
* | "Requirements waived" |
*
* @param {Task_Field_Waive_RequirementsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_waive_requirements = /** @type {((inputs?: Task_Field_Waive_RequirementsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Waive_RequirementsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_waive_requirements(inputs)
	return pt_br2_task_field_waive_requirements(inputs)
});